import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["loan", "addButton"];

    connect() {
        this.initializeLoans();
        this.updateUI();
    }

    initializeLoans() {
        this.loanTargets.forEach((loan) => {
            const amountField = loan.querySelector("input[name*='amount']");
            if (amountField && parseFloat(amountField.value) > 0) {
                loan.classList.remove("d-none"); // Afficher les prêts ayant un montant > 0
            }
        });
    }

    addLoan(event) {
        event.preventDefault();

        // Trouver le premier prêt masqué
        const hiddenLoan = this.loanTargets.find((loan) =>
            loan.classList.contains("d-none")
        );
        if (hiddenLoan) {
            hiddenLoan.classList.remove("d-none");
            hiddenLoan.parentElement.appendChild(hiddenLoan);
        }

        this.updateUI();
    }

    removeLoan(event) {
        event.preventDefault();

        const loan = event.target.closest("[data-bonifiedLoans-target='loan']");
        loan.classList.add("d-none");

        this.resetFieldForApiSync(loan.querySelector("input[name*='amount']"), "0");
        this.resetFieldForApiSync(loan.querySelector("input[name*='duration']"), "5");
        this.resetFieldForApiSync(loan.querySelector("input[name*='rate']"), "1");
        this.resetFieldForApiSync(loan.querySelector("input[name*='offset']"), "0");

        const form = loan.closest("form");
        if (form) {
            form.dispatchEvent(
                new CustomEvent("api-sync:refresh", {
                    bubbles: true,
                    detail: { scope: "listing_details", force: true },
                })
            );
        }

        this.updateUI();
    }

    /**
     * Remet à jour la valeur affichée, data-raw, champ hidden (number-format) et notifie api-sync.
     */
    resetFieldForApiSync(input, value) {
        if (!input) return;
        input.value = value;
        if (input.dataset && (input.dataset.controller || "").includes("number-format")) {
            input.dispatchEvent(new Event("number-format:normalize", { bubbles: true }));
        }
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    updateUI() {
        // Vérifie le nombre de prêts visibles
        const visibleLoans = this.loanTargets.filter(
            (loan) => !loan.classList.contains("d-none")
        ).length;

        // Cacher le bouton "Ajouter" si on atteint 5 prêts
        if (visibleLoans >= 4) {
            this.addButtonTarget.classList.add("d-none");
        } else {
            this.addButtonTarget.classList.remove("d-none");
        }

        // Empêcher de supprimer le dernier prêt
        this.loanTargets.forEach((loan) => {
            const removeButton = loan.querySelector(
                "[data-action='click->bonifiedLoans#removeLoan']"
            );
            if (removeButton) {
                removeButton.disabled = visibleLoans <= 1;
            }
        });
    }
}